import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions/permissionEngine';
import type { ResourceRate, RateCreatePayload, RateUpdatePayload } from '../types/rates.types';

export const ratesService = {
  async fetchRates() {
    const { data, error } = await supabase
      .from('rates')
      .select(`
        *,
        resource:resources!resource_id(name, code, unit),
        supplier:suppliers!supplier_id(name, code)
      `)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return (data || []) as unknown as ResourceRate[];
  },

  async createRate(userId: string, companyId: string, payload: RateCreatePayload) {
    await permissionEngine.assert(userId, 'inventory.rates.create', { companyId });

    const { data, error } = await supabase
      .from('rates')
      .insert({
        ...payload,
        created_by: userId,
        status: payload.status || 'active',
      })
      .select('id')
      .single();

    if (error) throw error;
    return data.id;
  },

  async updateRate(userId: string, companyId: string, id: string, payload: RateUpdatePayload) {
    await permissionEngine.assert(userId, 'inventory.rates.update', { companyId });

    const { error } = await supabase
      .from('rates')
      .update({
        ...payload,
      })
      .eq('id', id);

    if (error) throw error;
    return true;
  },

  async deleteRate(userId: string, companyId: string, id: string) {
    await permissionEngine.assert(userId, 'inventory.rates.delete', { companyId });

    const { error } = await supabase
      .from('rates')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  },
};
